import { Flex, Input } from '@aloft/toolkit-sui';

import { useState } from 'react';

export const CostApproachSummaryCommentary = ({
  costApproach,
}: {
  costApproach: { commentary: string; updateCommentary: (val: string) => void };
}) => {
  const [commentary, setCommentary] = useState(costApproach.commentary);

  return (
    <Flex marginTop="1rem" width="40rem">
      <Input
        type="multiline"
        onChange={setCommentary}
        value={commentary}
        onClear={() => setCommentary('')}
        onBlur={() => costApproach.updateCommentary(commentary)}
        resize="both"
        label="Commentary"
        size="sm"
      />
    </Flex>
  );
};
